import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './salesQuotationModal.css';
import { useLocation } from 'react-router-dom';

const SalesQuotationModal = ({ show, showPrintButton, onHide, handlecheckout,
  handleUpdateSQ, handlecancel, handleprint,isTableView }) => {
  const location = useLocation();

  
  const { additionalData } = location.state || {};
  const updateDocEntry=localStorage.getItem('docEntry');
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static" 
      keyboard={false}
      className='salesQuatationModal'
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {!showPrintButton ? 'Posting For' : 'Do you want to print?'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        {!showPrintButton ? (
          <>
            {/* <Button className='BtnSalesQut' onClick={docEntry && docEntry ?handleUpdateSQ:handlecheckout('Sales Quotation', true)}> */}
            <Button
              className="BtnSalesQut"
              onClick={() => {
                if (updateDocEntry &&!isTableView) {
                  handlecheckout('UpdateQuote', true)
                } else if (updateDocEntry && isTableView) {
                  handlecheckout('Quote', true);
                }else{
                  handlecheckout('Quote', true);
                }
              }}
            >

              {additionalData === 'CardCodeItemPage' ? 'Update Quote' : 'Quote'}
            </Button>
            <Button className='BtnSalesQut' onClick={() => handlecheckout('PurchaseOrder', true)}>
            Purchase Order</Button>
          </>
        ) : (
          <>

            <Button onClick={handleprint}>Print</Button>
            <Button onClick={handlecancel}>Cancel</Button>
          </>
        )}

      </Modal.Footer>
    </Modal>
  );
}

export default SalesQuotationModal;



// // modals/SalesQuotationModal.jsx
// import React from "react";
// import { Modal, Button } from "react-bootstrap";

// const SalesQuotationModal = ({
//   show,
//   onHide,
//   handleUpdateSQ,
//   handlePrint,
//   handleCancel,
//   isLoading,
//   showPrintButton,
// }) => {
//   return (
//     <Modal show={show} onHide={onHide}>
//       <Modal.Header closeButton>
//         <Modal.Title>Sales Quotation</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         {isLoading ? (
//           <div className="loading-indicator">Loading...</div>
//         ) : (
//           <div className="modal-body-content">
//             {showPrintButton && (
//               <Button variant="primary" onClick={handlePrint}>
//                 Print
//               </Button>
//             )}
//             <Button variant="secondary" onClick={handleUpdateSQ}>
//               Update
//             </Button>
//             <Button variant="danger" onClick={handleCancel}>
//               Cancel
//             </Button>
//           </div>
//         )}
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default SalesQuotationModal;
